import { Card, ListGroup, ListGroupItem } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { QueryResult } from '../../components/Alerts.tsx';
import ProtectedRoute from '../../components/ProtectedRoute.tsx';
import { useGetMessagesOfTheDayQuery } from '../../lib/model/kantoordagApi.ts';

export default function Motd() {
    const motdQuery = useGetMessagesOfTheDayQuery({
        since: 0
    })
    const {t} = useTranslation("motd");

    return (
        <ProtectedRoute authenticated={true}>
            <Card>
                <QueryResult query={motdQuery} message={t("loading_failed")}>
                    <ListGroup>
                        {
                            motdQuery.data ?
                                motdQuery.data.map( motd =>
                                    (
                                        <ListGroupItem>
                                            <h5>{motd.title}</h5>
                                            <p>
                                                {motd.message}
                                            </p>
                                        </ListGroupItem>
                                    )
                                )
                                : null
                        }
                    </ListGroup>
                </QueryResult>
            </Card>
        </ProtectedRoute>
    )
}
